import { useState, useRef } from "react";
import { PatentContext } from "../context/PatentContextProvider";
import { useLocation, useParams } from "react-router-dom";
import Navbar from "./Navbar";
import { useContext, useEffect } from "react";
import patentData from "../constants/us764382.json"
import { typeOfVoices } from "../constants/constants";
import { Footer } from "./Footer";
import Bot from "./ChattingBot";
import axios from "axios";
import { FaArrowUp } from "react-icons/fa6";


export default function PatentInfo() {
  const { patentId } = useParams();
  const { active, setActive } = useContext(PatentContext);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [voiceType, setVoiceType] = useState("Legal");
  const [enableChat, setEnableChat] = useState(false);
  const [loading, setLoading] = useState(false);
  const [audioPlaying, setAudioPlaying] = useState(false);
  const audioRef = useRef(null);
  const [textGenerated, setTextGenerated] = useState("");
  const [fullPatent, setFullPatent] = useState(patentData.patents);
  const [fullPatentData, setFullPatentData] = useState([])
  useEffect(() => {
    const FullPatentData = fullPatent?.find((patent) => patent?.patentId?.replace(/[\s,]/g, "") === patentId);
    setFullPatentData(FullPatentData)
  }, [])

  useEffect(() => {
    const generateSummary = async (languageStyle) => {
      if (!fullPatentData?.Claims) return;

      try {
        const getResponse = await axios.post(
          `${process.env.REACT_APP_API_PATH}/generateSummary`,
          {
            languageStyle: voiceType,
            activePatent: {
              patentNo: fullPatentData.patentId,
              abstract: fullPatentData.abstract,
              fieldOfInvention: fullPatentData.fieldOfInventor,
              claims: fullPatentData.Claims,
            }
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        const summaryGenerated =
          getResponse.data.response.candidates[0]?.content?.parts[0].text
            .replace(/[^\w\s]/g, "")
            .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
            .replace(/[^\w\s\']|_/g, "")
            .replace(/\s{2,}/g, "");
        if (summaryGenerated) {
          setTextGenerated(summaryGenerated);
        }
      } catch (error) {
        console.log(error, "err");
      }
    };
    generateSummary(voiceType);
  }, [voiceType]);

  async function speakSummary(text) {
    setLoading(true);
    // if (textGenerated) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_PATH}/generateSpeech/${patentId}-${voiceType}`,
        { text: text },
        {
          headers: { "Content-Type": "application/json" },
          responseType: "arraybuffer",
        },
      );

      const blob = new Blob([response.data], { type: "audio/mpeg" });
      const url = URL.createObjectURL(blob);
      // Stop and reset previous audio if playing
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      // Create new audio instance
      const audio = new Audio(url);
      audioRef.current = audio;

      audio.addEventListener("play", () => setAudioPlaying(true));
      audio.addEventListener("ended", () => {
        setAudioPlaying(false);
        URL.revokeObjectURL(url);
      });
      await audio.play();
      setLoading(false);
    } catch (error) {
      console.error("Error generating speech:", error);
      setLoading(false);
    }
    // }
  }

  //chatbot
  const openChat = () => {
    setEnableChat(true);
  };
  const closeChat = () => {
    setEnableChat(false);
  };

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setAudioPlaying(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 130) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setShowScrollButton(false);
  };

  useEffect(() => {
    setActive(active);
    localStorage.setItem("activePatent", JSON.stringify(active));
  }, []);
  
  return (
    <>
      <Navbar />
      <div className="bg-white overflow-y-auto pt-40">
        <div className="mx-auto w-[90%] py-4">
          <div className="border-y-4 border-gray-500">
            <div className="flex justify-between py-4">
              <div>
                <p className="text-lg">United State Patent</p>
                <p className="text-lg">Kind Code</p>
                <p className="text-lg">Date of Patent</p>
                <p className="text-lg">Inventor(s)</p>
              </div>
              <div className="text-end">
                <p>{fullPatentData.subPatentId}</p>
                <p className="py-1">{fullPatentData.Code}</p>
                <p>{fullPatentData.DateofPatent}</p>
                <p className="py-1">{fullPatentData.Inventor}</p>
              </div>
            </div>

          </div>
          <div className="border-b-4 border-gray-500 py-4">
            <h4 className="font-bold">{fullPatentData.title}</h4>
          </div>
          <div className="border-b-4 border-gray-500 py-4">
            <h4 className="py-4 font-bold text-2xl">Abstract</h4>
            <p>{fullPatentData.Abstract}</p>
          </div>
          <div className="w-full md:w-[35%] space-y-3">
            {fullPatentData.Inventor && (
              <div className="flex justify-between flex-wrap">
                <p className="font-bold">Inventor</p>
                <p className="text-right">{fullPatentData.Inventor}</p>
              </div>
            )}

            {fullPatentData.Applicant && (
              <div className="flex justify-between flex-wrap">
                <p className="font-bold">Applicant</p>
                <p className="text-right">{fullPatentData.Applicant}</p>
              </div>
            )}

            <div className="flex justify-between flex-wrap">
              <p className="font-bold">Family ID</p>
              <p className="text-right">{fullPatentData.familyId}</p>
            </div>

            <div className="flex justify-between flex-wrap">
              <p className="font-bold">Assignee</p>
              <p className="text-right">{fullPatentData.Assignee}</p>
            </div>

            <div className="flex justify-between flex-wrap">
              <p className="font-bold">Appl. No.</p>
              <p className="text-right">{fullPatentData.ApplNo}</p>
            </div>

            <div className="flex justify-between flex-wrap">
              <p className="font-bold">Filed</p>
              <p className="text-right">{fullPatentData.Filed}</p>
            </div>
          </div>
          <div className="relative group">
            <button className="min-w-[225px] md:min-w-[280px] lg:min-w-[302px] md:px-5 py-2 fixed  md:top-[22.5rem] md:right-10 lg:top-[21.8rem] lg:right-[10rem] right-4 px-2  text-sm  top-[21rem] justify-center items-center  bg-[#00A4E5] hover:bg-blue-400  font-semibold flex text-md lg:text-lg mt-[-15px] text-white">
              Summary Style ( {voiceType} )
              <svg
                class="w-2.5 h-2.5 ms-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
              <ul className="absolute right-0 md:w-[17.5rem] top-8 w-[14.1rem] lg:top-11 hidden lg:w-[19rem] bg-white  group-hover:block  border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {typeOfVoices
                  .filter((item) => item !== voiceType)
                  .map((val) => (
                    <li
                      className="block px-4 py-2 text-sm text-[#5c636e]  font-bold hover:bg-gray-600 hover:text-white"
                      onClick={() => setVoiceType(val)}
                    >
                      {val}
                    </li>
                  ))}
              </ul>
            </button>
          </div>
          <div className="border-b-4 border-gray-500 py-4">
            {fullPatentData.DocumentIdentifier && <>
              <h3 className="font-bold text-xl py-6">
                Prior Publication Data </h3>
              <div className="w-[35%] justify-between flex">
                <div>
                  <h4 className="font-bold">DocumentIdentifier</h4>
                  <p>{fullPatentData?.DocumentIdentifier}</p>
                </div>
                <div>
                  <h4 className="font-bold">PublicationDate</h4>
                  <p>{fullPatentData?.PublicationDate}</p>
                </div>
              </div>
            </>}
            {fullPatentData.relatedUsApplicationData1 && <>
              <h3 className="font-bold text-xl py-6">
                Related U.S. Application Data </h3>
              <div className=" justify-between flex">
                <div>
                  <p>{fullPatentData?.relatedUsApplicationData1}</p>
                  <p>{fullPatentData?.relatedUsApplicationData2}</p>
                </div>
              </div>
            </>}
          </div>
          <div className="border-b-4 border-gray-500 py-4">
            <h3 className="py-5 font-bold text-xl">Publication Classification</h3>
            <div className="w-full md:w-[55%] space-y-3">
              {fullPatentData?.IntCl && (
                <div className="flex justify-between flex-wrap">
                  <p className="font-bold">Int. Cl.:</p>
                  <p className="text-right font-bold">{fullPatentData.IntCl}</p>
                </div>
              )}

              {fullPatentData?.USCl && (
                <div className="flex justify-between flex-wrap">
                  <p className="font-bold">U.S. Cl</p>
                  <p className="text-right font-bold">{fullPatentData.USCl}</p>
                </div>
              )}

              {fullPatentData?.USPC && (
                <div className="flex justify-between flex-wrap">
                  <p>USPC</p>
                  <p className="text-right font-bold">{fullPatentData.USPC}</p>
                </div>
              )}
            </div>

            <div>
              <h3 className="py-5 font-bold text-xl">Field of Classification Search</h3>
            </div>
            <div className="w-full md:w-[35%] space-y-3">
              {fullPatentData?.classificationCpc && (
                <div className="flex justify-between flex-wrap">
                  <p className="font-bold">CPC:</p>
                  <p className="text-right">{fullPatentData.classificationCpc}</p>
                </div>
              )}

              <div className="flex justify-between flex-wrap">
                <p className="font-bold">USPC:</p>
                <p className="text-right">{fullPatentData?.FieldofClassificationSearchUSPC}</p>
              </div>
            </div>

          </div>
          <div className="border-b-4 border-gray-500 py-4">
            <h3 className="py-5 font-bold text-xl">References Cited</h3>
            <h3 className="font-bold text-xl">U.S. PATENT DOCUMENTS</h3>
            <div className="flex justify-between">
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <div>
                  <h4 className="font-bold text-lg">Patent No.</h4>
                  {Array.isArray(fullPatentData?.patentNumber) &&
                    fullPatentData.patentNumber.map((item, index) => (
                      <p key={index}>{item}</p>
                    ))}
                </div>

                <div>
                  <h4 className="font-bold text-lg">Issued Date</h4>
                  {Array.isArray(fullPatentData?.issuedDate) &&
                    fullPatentData.issuedDate.map((item, index) => (
                      <p key={index}>{item}</p>
                    ))}
                </div>

                <div>
                  <h4 className="font-bold text-lg">Patentee Name</h4>
                  {Array.isArray(fullPatentData?.PatenteeName) &&
                    fullPatentData.PatenteeName.map((item, index) => (
                      <p key={index}>{item}</p>
                    ))}
                </div>

                <div>
                  <h4 className="font-bold text-lg">U.S. Cl.</h4>
                  {Array.isArray(fullPatentData?.NEWUSCl) &&
                    fullPatentData.NEWUSCl.map((item, index) => (
                      <p key={index}>{item}</p>
                    ))}
                </div>

                <div>
                  <h4 className="font-bold text-lg">CPC</h4>
                  {Array.isArray(fullPatentData?.CPC) &&
                    fullPatentData.CPC.map((item, index) => (
                      <p key={index}>{item}</p>
                    ))}
                </div>
              </div>

            </div>
          </div>
          <div className="border-b-4 border-gray-500">
            <p className="py-4">Primary Examiner: {fullPatentData?.Examiner}</p>
            {fullPatentData.assistantExaminer && <><p className="py-4">Assistant Examiner: {fullPatentData?.assistantExaminer}</p></>}
          </div>
          <div className="border-b-4 border-gray-500 py-4">
            <h3 className="py-4 font-bold text-xl">Background/Summary</h3>
            {Array.isArray(fullPatentData?.BackgroundSummary) && fullPatentData?.BackgroundSummary.map((item) => {
              return (
                <><p className="my-4">{item}</p></>
              )
            })}
          </div>
          <div className=" border-gray-500 py-4">
          <div className=" grid grid-cols-1 md: grid-cols-2">
            {fullPatentData?.images?.map((image)=><img src={image} alt="patent related image"/>)}
            </div>
            <h3 className="py-4 font-bold text-xl">Description</h3>
            {Array.isArray(fullPatentData?.Description) && fullPatentData?.Description.map((item) => {
              return (
                <><p className="my-4">{item}</p></>
              )
            })}
            <h3 className="py-4 font-bold text-xl">Claims</h3>
            {Array.isArray(fullPatentData?.Claims) && fullPatentData?.Claims.map((item) => {
              return (
                <><p className="my-4">{item}</p></>
              )
            })}
          </div>
          <div>
          </div>
          <button className="flex items-center justify-center md:w-16 md:h-16  fixed bottom-[124px] right-4  py-2 px-2 sm:right-5 sm:py-2 sm-px-2 md:right-7 md:bottom-16 md:px-3 md:py-3 md:text-2xl  text-xl z-10 cursor-pointer hover:bg-[#5f6769] bg-[#393e46] text-white rounded-full lg:bottom-15 lg:right-4">
            {loading ? (
              <span class=" w-6 h-6 border-2 border-t-transparent border-white rounded-full inline-block animate-spin mr-2"></span>
            ) : audioPlaying ? (
              <svg
                class=" w-5 h-5 md:w-8 md:h-8"
                onClick={stopAudio}
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"></path>
              </svg>
            ) : (
              <svg
                onClick={() => speakSummary(textGenerated)}
                class="w-5 h-5 md:w-8 md:h-8 "
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"></path>
              </svg>
            )}
          </button>
          {enableChat && <Bot closeChat={closeChat} />}
          <button
            className="md:w-16 md:h-16  fixed bottom-[74px] right-4   py-2 px-2 sm:right-5 sm:py-2 sm-px-2 md:right-7 md:bottom-2 md:px-3 md:py-3 md:text-2xl  text-xl z-10 cursor-pointer hover:bg-[#5f6769] bg-[#393e46] text-white rounded-full lg:bottom-[140px] lg:right-4"
            onClick={openChat}
          >
            <svg
              class="w-5 h-5 md:w-9 md:h-9 lg:w-10 lg:h-10"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
              <path d="M8 12h.01"></path>
              <path d="M12 12h.01"></path>
              <path d="M16 12h.01"></path>
            </svg>
          </button>
          {showScrollButton && (
            <button
              className="fixed bottom-5  py-2 px-2 right-7 sm:py-2 sm-px-2 md:right-11 md:bottom-2 md:px-3 md:py-3 md:text-2xl  text-xl z-10 cursor-pointer hover:bg-[#5f6769] bg-[#393e46] text-white rounded-full lg:bottom-2 lg:right-5"
              onClick={scrollToTop}
            >
              <FaArrowUp />
            </button>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
